package one.healthium.meal_plans.tutorial.screen

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import one.healthium.base.preferences.AppPreferences
import one.healthium.meal_plans.domain.MealPlanInfoModel
import one.healthium.meal_plans.domain.MealPlanRepository
import one.healthium.ui.common.event_producer.EventProducer
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class PersonalMealPlanTutorialViewModel(
    private val mealPlanRepository: MealPlanRepository,
    private val appPreferences: AppPreferences,
) : BaseViewModel() {

    private val _state = MutableStateFlow(PersonalMealPlanTutorialUiState())
    val state = _state.asStateFlow()

    val events = EventProducer<PersonalMealPlanTutorialEvent>()

    val uiMessages = UiMessageManager()

    fun onActivatePersonalMealPlan() {
        launch {
            try {
                _state.update { it.copy(loading = true) }
                val mealPlanId = MealPlanInfoModel.PERSONAL_ID
                mealPlanRepository.setCurrentMealPlan(mealPlanId)
                events.trigger(PersonalMealPlanTutorialEvent.OpenMealPlan(mealPlanId))
            } catch (e: Exception) {
                Logger.e("Failed to set personal meal plan", e)
                uiMessages.add(UiMessage.throwable(e))
            } finally {
                _state.update { it.copy(loading = false) }
            }
        }
    }

    fun onMarkTutorialShown() {
        appPreferences.isMealPlanTutorialShown = true
    }
}